import {
  checkIsErrorToolOutput,
  type ErrorToolOutput,
} from "@repo/app-types/agents/errorToolOutput";
import type { SelectedPlaybook } from "@repo/app-types/agents/selectedPlaybook";
import { renderPlural } from "@repo/app-types/helpers/utilities";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

/** The fields of a list-customer-interactions page this row reads. */
interface ListCustomerInteractionsPage {
  /** Absent on threads from the removed copilot tool of the same name. */
  interactions?: readonly unknown[];
  /** The playbook the page is from. */
  playbook?: SelectedPlaybook;
}

export const ListCustomerInteractionsTool: ToolComponent<
  unknown,
  ListCustomerInteractionsPage | ErrorToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return "Retrieving customer interactions...";
    }

    if (checkIsErrorToolOutput(props.output)) {
      return "An error occurred while retrieving customer interactions";
    }

    if (!props.output.interactions) {
      return "Retrieved customer interactions";
    }

    const summary = renderPlural(props.output.interactions.length, {
      zero: "No customer interactions found",
      one: "Retrieved 1 customer interaction",
      other: (count) =>
        `Retrieved ${count.toLocaleString()} customer interactions`,
    });
    return props.output.playbook
      ? `${summary} · ${props.output.playbook.name}`
      : summary;
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
